import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { callEdgeApi } from "@/lib/edge-api";

const inputSchema = z.object({
  name: z.string().trim().min(1, "Nome obbligatorio").max(200),
  email: z.string().trim().email("Email non valida").max(200),
  phone: z.string().trim().max(40).optional().or(z.literal("")),
  message: z.string().trim().min(1, "Messaggio obbligatorio").max(2000),
});

export const submitContatti = createServerFn({ method: "POST" })
  .inputValidator((i) => inputSchema.parse(i))
  .handler(async ({ data }): Promise<{ ok: true; telegramSent: boolean }> => {
    return await callEdgeApi("submit_contatti", data);
  });